import type { Pendo } from '#shared/pendo'

export const PENDO_STORAGE_PREFIXES = ['_pendo_', 'pendo_'] as const

// Mirrors Pendo's install snippet
export function createPendoStub(): Pendo {
  const queue: unknown[][] = []
  const enqueue = (method: string) => (...args: unknown[]) => {
    queue[method === 'initialize' ? 'unshift' : 'push']([method, ...args])
  }

  return {
    _q: queue,
    initialize: enqueue('initialize'),
    identify: enqueue('identify'),
    updateOptions: enqueue('updateOptions'),
    pageLoad: enqueue('pageLoad'),
    track: enqueue('track'),
  }
}
